export default {
  "navbar": {
    "sar": "صار",
    "logout": "تسجيل الخروج",
    "login": "تسجيل الدخول",
    "search": "بحث...",
    "userAvatar": "صورة المستخدم",
    "admin": "مدير",
    "administrator": "مدير النظام",
    "apps": "التطبيقات",
    "expand": "توسيع",
    "notifications": "الإشعارات",
    "settings": "إعدادات النظام",
    "logoutConfirmTitle": "تأكيد تسجيل الخروج",
    "logoutConfirmMessage": "هل أنت متأكد من تسجيل الخروج؟",
    "logoutSuccess": "تم تسجيل الخروج بنجاح",
    "logoutError": "فشل تسجيل الخروج. يرجى المحاولة مرة أخرى."
  },
  "menu": {
    "main": "الرئيسية",
    "settings": "إعدادات النظام",
    "homepage": "الصفحة الرئيسية",
    "buy4meOrders": "طلبات اشتريلي",
    "ship4meOrders": "طلبات اشحنلي",
    "orderGroups": "مجموعات الطلبات",
    "buyForMeGroups": "مجموعات اشتريلي",
    "shipForMeGroups": "مجموعات اشحنلي",
    "customers": "العملاء",
    "users": "المستخدمين",
    "userRoles": "صلاحيات المستخدمين",
    "invoices": "الفواتير",
    "paymentMethods": "طرق الدفع",
    "paymentGateways": "بوابات الدفع",
    "shippingCompanies": "شركات الشحن",
    "taxProfiles": "ملفات الضرائب",
    "currencies": "العملات",
    "coupons": "الكوبونات",
    "categories": "تصنيفات المنتجات",
    "countries": "البلاد",
    "cities": "المدن",
    "measurementUnits": "وحدات القياس",
    "dangerousItems": "المواد الخطرة",
    "faq": "الأسئلة الشائعة",
    "faqCategories": "تصنيفات الأسئلة الشائعة",
    "contactRequests": "طلبات الاتصال",
    "recovery": "استعادة المحذوفات",
    "recaptchaSettings": "إعدادات reCAPTCHA",
    "cms": "إدارة المحتوى",
    "sliders": "الصور المتحركة (Sliders)",
    "generalInfo": "معلومات عامة"
  },
  "common": {
    "welcome": "مرحباً",
    "loading": "جاري التحميل...",
    "error": "خطأ",
    "success": "نجح",
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "add": "إضافة",
    "search": "بحث",
    "filter": "تصفية",
    "export": "تصدير",
    "import": "استيراد",
    "refresh": "تحديث",
    "close": "إغلاق",
    "confirm": "تأكيد",
    "yes": "نعم",
    "no": "لا",
    "submit": "إرسال",
    "reset": "إعادة تعيين",
    "clear": "مسح",
    "select": "اختيار",
    "selectAll": "اختيار الكل",
    "deselectAll": "إلغاء اختيار الكل",
    "next": "التالي",
    "previous": "السابق",
    "first": "الأول",
    "last": "الأخير",
    "page": "صفحة",
    "of": "من",
    "items": "عناصر",
    "item": "عنصر",
    "total": "المجموع",
    "showing": "عرض",
    "to": "إلى",
    "from": "من",
    "show": "عرض",
    "entries": "إدخالات",
    "all": "الكل",
    "language": "اللغة",
    "english": "English",
    "arabic": "العربية",
    "orders": "الطلبات",

    // Form sections
    "basicInformation": "المعلومات الأساسية",
    "shippingInformation": "معلومات الشحن",
    "productLink": "رابط المنتج",
    "merchantName": "اسم التاجر",
    "description": "الوصف",
    "quantity": "الكمية",
    "extendedDescription": "الوصف المفصل",
    "originCountry": "بلد المنشأ",
    "destinationCountry": "بلد الوجهة",

    // Form placeholders
    "enterProductLink": "أدخل رابط المنتج",
    "enterMerchantName": "أدخل اسم التاجر",
    "enterDescription": "أدخل الوصف",
    "enterExtendedDescription": "أدخل الوصف المفصل",
    "selectOriginCountry": "اختر بلد المنشأ"
  },
  "forms": {
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "confirmPassword": "تأكيد كلمة المرور",
    "phone": "الهاتف",
    "address": "العنوان",
    "city": "المدينة",
    "country": "البلد",
    "zipCode": "الرمز البريدي",
    "description": "الوصف",
    "status": "الحالة",
    "date": "التاريخ",
    "time": "الوقت",
    "amount": "المبلغ",
    "quantity": "الكمية",
    "price": "السعر",
    "total": "المجموع",
    "discount": "الخصم",
    "tax": "الضريبة",
    "shipping": "الشحن",
    "notes": "ملاحظات",
    "comments": "تعليقات",
    "updating": "جاري التحديث...",
    "selectOption": "اختر خيار",
    "yes": "نعم",
    "no": "لا",
    "collected": "تم التحصيل",
    "notCollected": "لم يتم التحصيل",
    "permissions": "صلاحيات"
  },
  "validation": {
    "required": "هذا الحقل مطلوب",
    "email": "يرجى إدخال عنوان بريد إلكتروني صحيح",
    "password": "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    "confirmPassword": "كلمات المرور غير متطابقة",
    "phone": "يرجى إدخال رقم هاتف صحيح",
    "minLength": "الحد الأدنى للطول هو {{min}} أحرف",
    "maxLength": "الحد الأقصى للطول هو {{max}} أحرف",
    "min": "الحد الأدنى للقيمة هو {{min}}",
    "max": "الحد الأقصى للقيمة هو {{max}}"
  },
  "status": {
    "collected": "تم التحصيل",
    "notCollected": "لم يتم التحصيل",
    "received": "تم الاستلام",
    "notReceived": "لم يتم الاستلام"
  },
  "buttons": {
    "cancel": "إلغاء",
    "selectAll": "اختيار الكل",
    "deselectAll": "إلغاء اختيار الكل"
  },
  "table": {
    "number": "رقم",
    "id": "المعرف"
  },
  "select": "اختر",
  "noOptions": "لا توجد خيارات متاحة",
  "loading": "جاري التحميل...",
  "actions": {
    "calculate": "احسب",
    "calculating": "جاري الحساب...",
    "reset": "إعادة تعيين",
    "close": "إغلاق",
    "back": "رجوع"
  },
  "messages": {
    "calculationSuccess": "تم الحساب بنجاح",
    "calculationFailed": "فشل في الحساب",
    "networkError": "حدث خطأ في الشبكة"
  },
  "form": {
    "orderDetails": "تفاصيل الطلب",
    "link": "رابط المنتج",
    "merchantName": "اسم التاجر",
    "description": "الوصف",
    "quantity": "الكمية",
    "dimensions": "الأبعاد",
    "width": "العرض",
    "height": "الارتفاع",
    "length": "الطول",
    "weight": "الوزن",
    "pricing": "التسعير",
    "itemPrice": "سعر المنتج",
    "shippingOptions": "خيارات الشحن",
    "originCountry": "بلد المنشأ",
    "destinationCountry": "بلد الوجهة",
    "shippingCompany": "شركة الشحن",
    "currency": "العملة",
    "deliveryMode": "نوع التوصيل",
    "itemType": "نوع المنتج",
    "hasShippingInsurance": "تأمين الشحن",
    "enableDGFees": "رسوم البضائع الخطرة",
    "selectCountry": "اختر البلد",
    "selectShippingCompany": "اختر شركة الشحن",
    "selectCurrency": "اختر العملة"
  },
  "deliveryMode": {
    "economy": "اقتصادي",
    "fast": "سريع"
  },
  "itemType": {
    "normal": "عادي",
    "dangerous": "خطر"
  },
  "calculator": {
    "result": "نتيجة الحساب",
    "orderPrice": "سعر الطلب",
    "shippingCost": "تكلفة الشحن",
    "servicePrice": "سعر الخدمة",
    "totalPrice": "السعر الإجمالي",
    "exchangeRate": "سعر الصرف",
    "dimensionalWeight": "الوزن الحجمي",
    "actualWeight": "الوزن الفعلي",
    "pricePerLB": "السعر لكل رطل",
    "insurance": "التأمين",
    "fuelCost": "رسوم الوقود",
    "dgFees": "رسوم البضائع الخطرة",
    "shippingCompany": "شركة الشحن",
    "currency": "العملة"
  },
  "orderGroups": {
    "kinds": {
      "buyForMe": {
        "title": "مجموعات اشتريلي",
        "subtitle": "مجموعات عناصر اشتريلي من بلد منشأ واحد",
        "detailsTitle": "مجموعة اشتريلي #{{group}}"
      },
      "shipForMe": {
        "title": "مجموعات اشحنلي",
        "subtitle": "مجموعات عناصر اشحنلي من بلد منشأ واحد",
        "detailsTitle": "مجموعة اشحنلي #{{group}}"
      }
    },
    "title": "مجموعات الطلبات",
    "subtitle": "كل طلب هو مجموعة من العناصر من بلد منشأ واحد",
    "detailsTitle": "مجموعة الطلبات رقم {{group}}",
    "detailsSubtitle": "إجماليات المجموعة والعناصر والفواتير والسجل",
    "loading": "جاري التحميل...",
    "loadingItems": "جاري تحميل العناصر...",
    "notFound": "مجموعة الطلبات غير موجودة",
    "items": "العناصر",
    "emptyItems": "لا توجد عناصر في هذه المجموعة",
    "empty": "لا توجد مجموعات طلبات",
    "activeOfTotal": "العناصر النشطة / جميع العناصر",
    "yes": "نعم",
    "no": "لا",
    "saving": "جاري الحفظ...",
    "noteOptional": "ملاحظة (اختياري)",
    "messages": {
      "loadError": "تعذر تحميل مجموعات الطلبات",
      "actionFailed": "تعذر إتمام العملية",
      "invalidNumber": "أدخل رقماً يساوي صفراً أو أكثر",
      "recalculated": "تمت إعادة حساب المجموعة وحفظها",
      "itemRefunded": "تم استرداد العنصر وإعادة حساب المجموعة",
      "groupRefunded": "تم استرداد مجموعة الطلبات",
      "refundApproved": "تمت الموافقة على الاسترداد",
      "refundRejected": "تم رفض الاسترداد",
      "statusChanged": "تم تحديث حالة العنصر"
    },
    "types": {
      "buyForMe": "اشتريلي",
      "shipForMe": "اشحنلي"
    },
    "payment": {
      "noInvoice": "لا توجد فاتورة",
      "paid": "مدفوعة",
      "partial": "مدفوعة جزئياً",
      "pending": "غير مدفوعة"
    },
    "columns": {
      "group": "المجموعة",
      "type": "النوع",
      "origin": "المنشأ",
      "destination": "الوجهة",
      "customer": "العميل",
      "items": "العناصر",
      "statuses": "حالات العناصر",
      "total": "إجمالي المجموعة (دولار)",
      "paid": "المدفوع (دولار)",
      "remaining": "المتبقي (دولار)",
      "payment": "الدفع",
      "created": "تاريخ الإنشاء",
      "actions": "الإجراءات",
      "number": "الرقم",
      "merchant": "التاجر",
      "quantity": "الكمية",
      "status": "الحالة",
      "invoice": "الفاتورة",
      "amount": "المبلغ (دولار)",
      "method": "طريقة الدفع",
      "refund": "الاسترداد",
      "date": "التاريخ",
      "item": "العنصر",
      "summary": "الملخص",
      "user": "المستخدم"
    },
    "filters": {
      "search": "بحث",
      "searchPlaceholder": "رقم المجموعة أو رقم العنصر أو العميل أو البلد",
      "type": "النوع",
      "allTypes": "كل الأنواع",
      "status": "حالة العنصر",
      "allStatuses": "كل الحالات",
      "from": "أنشئت من",
      "to": "أنشئت إلى",
      "pendingRefund": "المجموعات التي لديها استرداد بانتظار الموافقة فقط",
      "statusHint": "تطابق المجموعة الحالة إذا كان أحد عناصرها بهذه الحالة."
    },
    "actions": {
      "viewItem": "عرض العنصر",
      "open": "فتح",
      "confirm": "تأكيد",
      "cancel": "إلغاء",
      "editItem": "تعديل العنصر",
      "manage": "إدارة",
      "back": "رجوع"
    },
    "refund": {
      "pendingShort": "استرداد معلق",
      "pendingTotal": "استرداد بانتظار الموافقة (دولار)",
      "wholeGroup": "استرداد المجموعة كاملة",
      "item": "استرداد هذا العنصر",
      "confirmItem": "استرداد العنصر {{item}} وإعادة حساب المجموعة؟",
      "confirmGroup": "استرداد جميع العناصر النشطة في المجموعة رقم {{group}}؟",
      "confirmApprove": "الموافقة على استرداد {{amount}} دولار؟ وافق فقط بعد إعادة المبلغ للعميل.",
      "confirmReject": "رفض استرداد {{amount}} دولار؟",
      "pending": "بانتظار الموافقة",
      "completed": "مكتمل",
      "rejected": "مرفوض",
      "amount": "الاسترداد",
      "completedAmount": "تمت إعادته",
      "approve": "الموافقة على الاسترداد",
      "reject": "رفض الاسترداد"
    },
    "voucher": {
      "code": "رمز القسيمة",
      "apply": "تطبيق القسيمة",
      "applied": "تم تطبيق القسيمة",
      "current": "قسيمة المجموعة الحالية: {{code}}",
      "groupNote": "القسيمة تُطبَّق على المجموعة كلها.",
      "title": "القسيمة",
      "discount": "خصم القسيمة"
    },
    "summary": {
      "goodsValue": "قيمة البضاعة (دولار، غير محتسبة)",
      "serviceOnlyNote": "مجموعة اشحنلي تُحتسب عليها الخدمة فقط؛ قيمة البضاعة ليست ضمن الإجمالي.",
      "itemTotals": "إجماليات العناصر النشطة",
      "activeItems": "العناصر النشطة",
      "chosenWeight": "الوزن المحتسب",
      "orderPrice": "سعر الطلب (دولار)",
      "merchantFees": "توصيل التاجر (دولار)",
      "tax": "الضريبة (دولار)",
      "insurance": "التأمين (دولار)",
      "paymentFees": "رسوم الدفع (دولار)",
      "dangerous": "بضائع خطرة"
    },
    "calc": {
      "title": "حساب المجموعة",
      "ready": "جاهز",
      "notReady": "لا يمكن الحساب بعد",
      "shippingCompany": "شركة الشحن",
      "pricePerLb": "السعر لكل باوند",
      "shippingCost": "تكلفة الشحن",
      "fuel": "رسوم الوقود",
      "dgFees": "رسوم البضائع الخطرة",
      "localDelivery": "التوصيل المحلي",
      "clearance": "التخليص",
      "servicePrice": "سعر خدمة المجموعة",
      "commission": "رسوم الخدمة (العمولة)",
      "total": "إجمالي المجموعة",
      "chooseShippingCompany": "اختر شركة الشحن",
      "paymentType": "نوع الدفع",
      "choosePaymentType": "اختر نوع الدفع",
      "partialPercent": "نسبة الدفعة الأولى %",
      "partialPercentHint": "{{min}}% على الأقل",
      "partialPercentFixed": "ثابتة بعد إصدار فاتورة المجموعة",
      "firstPayment": "الدفعة الأولى ({{percent}}%)",
      "paidAtDelivery": "يُدفع عند التسليم",
      "deliveryMode": "نوع التوصيل",
      "originCountry": "بلد المصدر",
      "destinationCountry": "بلد الوجهة",
      "city": "المدينة",
      "chooseCountry": "اختر البلد",
      "chooseCity": "اختر المدينة",
      "chooseDeliveryMode": "اختر نوع التوصيل",
      "manualPrice": "سعر يدوي لكل باوند",
      "manualPricePlaceholder": "فارغ = استخدام جدول الأسعار",
      "packaging": "التغليف",
      "save": "إعادة الحساب والحفظ",
      "unavailable": "تعذّر تحميل حساب المجموعة."
    },
    "invoices": {
      "title": "فواتير المجموعة",
      "closed": "مغلقة",
      "collected": "محصلة",
      "pending": "معلقة",
      "received": "مستلمة",
      "downloadPdf": "تحميل PDF",
      "empty": "لا توجد فواتير للمجموعة"
    },
    "tabs": {
      "calculation": "الحساب",
      "summary": "الملخص",
      "items": "العناصر",
      "invoices": "الفواتير",
      "activity": "السجل"
    },
    "itemEditor": {
      "title": "مدخلات العنصر",
      "loading": "جارٍ تحميل العنصر…",
      "loadError": "تعذر تحميل مدخلات العنصر.",
      "readOnly": "ليس لديك صلاحية تعديل هذا العنصر.",
      "termsMissing": "اختر مسار المجموعة (بلد المصدر وبلد الوجهة والمدينة) ونوع الدفع وشركة الشحن ونوع التوصيل من تبويب الحساب أولاً. تطبَّق على كل عناصر المجموعة.",
      "saved": "تم حفظ العنصر",
      "calculated": "تم احتساب العنصر",
      "reset": "تمت إعادة تعيين العنصر",
      "rejectNoteRequired": "الملاحظة مطلوبة لرفض عنصر قيد الانتظار"
    },
    "itemTabs": {
      "details": "التفاصيل",
      "status": "الحالة",
      "log": "السجل",
      "summary": "الملخص"
    },
    "status": {
      "orderNumber": "رقم الطلب",
      "shippingOrderNumber": "رقم طلب الشحن",
      "reorderNumber": "رقم إعادة الطلب",
      "receiptNumber": "رقم إيصال المندوب",
      "paymentGateway": "بوابة الدفع",
      "chooseGateway": "اختر بوابة",
      "collectNote": "هذا التغيير يجعل فواتير المجموعة المفتوحة محصّلة.",
      "note": "لكل عنصر حالته الخاصة؛ المجموعة ليس لها حالة.",
      "rejectedFinal": "تم رفض هذا العنصر ولا يمكن استعادته.",
      "cancelledFinal": "تم إلغاء هذا العنصر ولا يمكن استعادته.",
      "acceptForCustomer": "قبول بالنيابة عن العميل",
      "rejectForCustomer": "رفض بالنيابة عن العميل",
      "newStatus": "الحالة الجديدة",
      "choose": "اختر حالة",
      "comment": "تعليق",
      "reference": "الرقم المرجعي",
      "apply": "تغيير الحالة",
      "confirmAccept": "قبول العنصر {{item}} بالنيابة عن العميل؟",
      "confirmReject": "رفض العنصر {{item}} بالنيابة عن العميل؟ لا يمكن استعادة العنصر المرفوض."
    },
    "activity": {
      "emptyItem": "لا يوجد نشاط مسجل لهذا العنصر",
      "empty": "لا يوجد نشاط مسجل لهذه المجموعة",
      "group": "المجموعة"
    }
  }
};
